import { Principal } from '@icp-sdk/core/principal';

export interface FilterTrade { who: string; buy: boolean; usd: number | null; tokens: bigint }
export interface TradeFilter { wallet: string; side: 'all' | 'buy' | 'sell'; min: string; max: string }
export const emptyTradeFilter = (): TradeFilter => ({ wallet: '', side: 'all', min: '', max: '' });
export function validSize(value: string) { return value === '' || (Number.isFinite(Number(value)) && Number(value) >= 0); }
export function tradeFilterError(filter: TradeFilter): string | null {
  if (filter.wallet.trim()) {
    try { Principal.fromText(filter.wallet.trim()); }
    catch { return 'Enter a complete, valid ICP principal.'; }
  }
  if (!validSize(filter.min) || !validSize(filter.max) || (filter.min !== '' && filter.max !== '' && Number(filter.min) > Number(filter.max))) return 'Enter non-negative sizes with the minimum no greater than the maximum.';
  return null;
}
export function filterTrades<T extends FilterTrade>(trades: T[], filter: TradeFilter): T[] {
  if (!validSize(filter.min) || !validSize(filter.max) || (filter.min !== '' && filter.max !== '' && Number(filter.min) > Number(filter.max))) return [];
  const wallet = filter.wallet.trim();
  return trades.filter(trade =>
    (!wallet || trade.who === wallet) &&
    (filter.side === 'all' || trade.buy === (filter.side === 'buy')) &&
    (filter.min === '' || (trade.usd !== null && trade.usd >= Number(filter.min))) &&
    (filter.max === '' || (trade.usd !== null && trade.usd <= Number(filter.max)))
  );
}
